/* Корпус светлый в светлой теме и графитовый в тёмной; индикаторы
   те же, что на дашборде (--led-*). */
.faceplate {
  --fp-ear: #CDD5DE;
  --fp-screw: #9AA6B2;
  --fp-screw-ring: #B4BEC9;
  --fp-body: #E3E8EE;
  --fp-body-edge: #C5CED8;
  --fp-jack: #2B3440;
  --fp-jack-edge: #9AA6B2;
  --fp-cage: #F4F6F8;
  --fp-cage-edge: #94A3B8;
  --fp-text: #64748B;
  --fp-led-off: #B8C2CD;

  display: block;
  width: 100%;
  height: auto;
  overflow: visible;
}

:global(html.dark) .faceplate {
  --fp-ear: #273244;
  --fp-screw: #0B1220;
  --fp-screw-ring: #3B4A60;
  --fp-body: var(--dev-body);
  --fp-body-edge: var(--dev-edge);
  --fp-jack: var(--dev-hole);
  --fp-jack-edge: #2A3648;
  --fp-cage: #8EA3B8;
  --fp-cage-edge: #B4C3D2;
  --fp-text: #7C8DA3;
  --fp-led-off: #1E293B;
}

.ear { fill: var(--fp-ear); }
.screw { fill: var(--fp-screw); stroke: var(--fp-screw-ring); stroke-width: 1; }
.body { fill: var(--fp-body); stroke: var(--fp-body-edge); stroke-width: 1; }

.jack { fill: var(--fp-jack); stroke: var(--fp-jack-edge); stroke-width: 1; }
.cage { fill: var(--fp-cage); stroke: var(--fp-cage-edge); stroke-width: .75; }

.num {
  font: 600 7.5px var(--mono);
  fill: var(--fp-text);
  text-anchor: middle;
  font-variant-numeric: tabular-nums;
}

/* Надписи шелкографией — как на корпусе */
.silk {
  font: 600 7px var(--sans);
  fill: var(--fp-text);
  letter-spacing: .06em;
}

.ledOff { fill: var(--fp-led-off); }

/* Линк поднимается: сначала янтарный — согласование, затем зелёный */
.ledUp {
  fill: var(--fp-led-off);
  animation: linkUp .6s ease-out both;
}

@keyframes linkUp {
  0%   { fill: var(--fp-led-off); }
  35%  { fill: var(--led-checked); }
  60%  { fill: var(--led-checked); }
  100% { fill: var(--led-clean); }
}

.pwr { fill: var(--led-clean); }

/* SYS мигает при загрузке, затем горит ровно */
.sys {
  fill: var(--fp-led-off);
  animation: sysBoot 1.2s steps(1, end) both;
}

@keyframes sysBoot {
  0%   { fill: var(--led-checked); }
  17%  { fill: var(--fp-led-off); }
  33%  { fill: var(--led-checked); }
  50%  { fill: var(--fp-led-off); }
  67%  { fill: var(--led-checked); }
  84%  { fill: var(--fp-led-off); }
  100% { fill: var(--led-clean); }
}

/* Без движения — сразу итоговое состояние, без задержек волны */
@media (prefers-reduced-motion: reduce) {
  .ledUp, .sys { animation: none; fill: var(--led-clean); }
}
